import { createHttpService } from '../ApiService';
import {
  StudentPerformanceReview,
  StaffPerformanceReview,
  ExternalPerformanceReview,
  PerformanceSummary,
} from '../../views/modules/analytics/performance/performance.interfaces';
import { mockStudentPerformanceReviews, mockStudentPerformanceSummary } from '../../__mocks__/analytics/mockAnalyticsPerformanceStudents';
import { mockStaffPerformanceReviews, mockStaffPerformanceSummary } from '../../__mocks__/analytics/mockAnalyticsPerformanceStaff';
import { mockExternalPerformanceReviews, mockExternalPerformanceSummary } from '../../__mocks__/analytics/mockAnalyticsPerformanceExternal';
import isAppWithMock from 'src/utils/isAppWithMock';

export const useAnalyticsService = () => {
  const httpAPI = createHttpService();
  const baseAnalyticsPath = '/analytics';
  const withMockData = isAppWithMock();

  const getStudentPerformanceReviews = (): Promise<StudentPerformanceReview[]> => {
    if (withMockData) {
      return Promise.resolve(mockStudentPerformanceReviews);
    }
    return httpAPI.get<StudentPerformanceReview[]>(`${baseAnalyticsPath}/performance/students`);
  };

  const getStudentPerformanceSummary = (): Promise<PerformanceSummary> => {
    if (withMockData) {
      return Promise.resolve(mockStudentPerformanceSummary);
    }
    return httpAPI.get<PerformanceSummary>(`${baseAnalyticsPath}/performance/students/summary`);
  };

  const getStaffPerformanceReviews = (): Promise<StaffPerformanceReview[]> => {
    if (withMockData) {
      return Promise.resolve(mockStaffPerformanceReviews);
    }
    return httpAPI.get<StaffPerformanceReview[]>(`${baseAnalyticsPath}/performance/staff`);
  };

  const getStaffPerformanceSummary = (): Promise<PerformanceSummary> => {
    if (withMockData) {
      return Promise.resolve(mockStaffPerformanceSummary);
    }
    return httpAPI.get<PerformanceSummary>(`${baseAnalyticsPath}/performance/staff/summary`);
  };

  const getExternalPerformanceReviews = (): Promise<ExternalPerformanceReview[]> => {
    if (withMockData) {
      return Promise.resolve(mockExternalPerformanceReviews);
    }
    return httpAPI.get<ExternalPerformanceReview[]>(`${baseAnalyticsPath}/performance/external`);
  };

  const getExternalPerformanceSummary = (): Promise<PerformanceSummary> => {
    if (withMockData) {
      return Promise.resolve(mockExternalPerformanceSummary);
    }
    return httpAPI.get<PerformanceSummary>(`${baseAnalyticsPath}/performance/external/summary`);
  };

  return {
    getStudentPerformanceReviews,
    getStudentPerformanceSummary,
    getStaffPerformanceReviews,
    getStaffPerformanceSummary,
    getExternalPerformanceReviews,
    getExternalPerformanceSummary,
  };
};
